<template>
  <div>
    <v-dropdown placement="right">
      <template v-slot:button>
        <button class="rounded-full mr-3 ml-1.5 text-gray-400 hover:text-gray-800">
          <i class="fa fa-ellipsis-v text-lg "></i>
        </button>
      </template>
      <template v-slot:content>
        <ul class="w-56 font-poppins top-10 px-1.5 py-1.5">
          <li v-if="hasTeacherPermissionsInCourse && getCurrentDiscussion.sequence_id === null" class="relative">
            <div
              class="flex items-center cursor-pointer hover:bg-gray-100 px-3 py-1.5 rounded"
              @click.stop="toggleSubmenu"
            >
              <i class="fa-solid text-indigo-600 fa-forward text-base"></i>
              <span class="ml-4">Start Follow Up</span>
              <i class="fa ml-auto" :class="submenuOpen ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </div>
            <div
              v-if="submenuOpen"
              v-click-outside="closeSubmenu"
              class="absolute right-full top-0 mt-0 mr-1"
            >
              <ul class="w-32 font-poppins py-1 px-1 bg-white shadow-lg border border-solid border-gray-100 rounded-md">
                <li
                  @click.stop="handleStartFollowUp('written')"
                  class="flex items-center space-x-2 px-2 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer"
                >
                  <div class="flex items-center justify-center h-5 w-5 rounded-full bg-blue space-x-2.5">
                    <img src="/static/roundtable_icons/written_icon.svg" class="w-3 h-3"/>
                  </div>
                  <span>Written</span>
                </li>
                <li
                  @click.stop="handleStartFollowUp('verbal')"
                  class="flex items-center space-x-2 px-2 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer"
                >
                  <div class="flex items-center justify-center h-5 w-5 rounded-full bg-green-light space-x-2.5">
                    <img src="/static/roundtable_icons/verbal_icon.svg" class="w-3 h-3"/>
                  </div>
                  <span>Verbal</span>
                </li>
              </ul>
            </div>
          </li>
          <li v-if="hasTeacherPermissionsInCourse && getCurrentDiscussion.sequence_id !== null && getCurrentDiscussion.roundtables_sequence.length < 9" class="relative">
            <div
              class="flex items-center cursor-pointer hover:bg-gray-100 px-3 py-1.5 rounded"
              @click.stop="toggleSubmenu"
            >
              <i class="fa-solid text-indigo-600 fa-forward text-base"></i>
              <span class="ml-4">Continue Follow Up</span>
              <i class="fa ml-auto" :class="submenuOpen ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </div>
            <div
              v-if="submenuOpen"
              v-click-outside="closeSubmenu"
              class="absolute right-full top-0 mt-0 mr-1"
            >
              <ul class="w-32 font-poppins py-1 px-1 bg-white shadow-lg border border-solid border-gray-100 rounded-md">
                <li
                  @click.stop="handleStartFollowUp('written')"
                  class="flex items-center space-x-2 px-2 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer"
                >
                  <div class="flex items-center justify-center h-5 w-5 rounded-full bg-blue space-x-2.5">
                    <img src="/static/roundtable_icons/written_icon.svg" class="w-3 h-3"/>
                  </div>
                  <span>Written</span>
                </li>
                <li
                  @click.stop="handleStartFollowUp('verbal')"
                  class="flex items-center space-x-2 px-2 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer"
                >
                  <div class="flex items-center justify-center h-5 w-5 rounded-full bg-green-light space-x-2.5">
                    <img src="/static/roundtable_icons/verbal_icon.svg" class="w-3 h-3"/>
                  </div>
                  <span>Verbal</span>
                </li>
              </ul>
            </div>
          </li>
          <!-- <li
            v-if="hasTeacherPermissionsInCourse && getCurrentDiscussion.sequence_id === null"
            class="text-indigo-600 sample group px-3 py-2 rounded-t flex items-center w-full h-9 cursor-pointer hover:bg-gray-100"
            @click="$emit('showFollowUp')"
          >
            <i class="fa-solid fa-forward text-base"></i>
            <span class="ml-4">Start Follow Up</span>
          </li> -->
          <!-- <li
            v-if="hasTeacherPermissionsInCourse && getCurrentDiscussion.sequence_id !== null && getCurrentDiscussion.roundtables_sequence.length < 5"
            class="text-indigo-600 sample group px-3 py-2 rounded-t flex items-center w-full h-9 cursor-pointer hover:bg-gray-100"
            @click="$emit('showFollowUp')"
          >
            <i class="fa-solid fa-forward text-base"></i>
            <span class="ml-4">Continue a Follow Up!</span>
          </li> -->
          <li
            class="sample group px-3 py-2 rounded-t flex items-center w-full h-9 cursor-pointer hover:bg-gray-100"
            @click="handleAddToUniverse()"
          >
            <i class="fa-solid fa-folder-open text-sm"></i>
            <span class="ml-4">Add to My Portfolio</span>
          </li>
          <li
            @click="$emit('rtIntegrationAssignment', true)"
            class="sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100"
          >
            <i class="fas fa-sync text-base w-4"></i>
            <span class="ml-4"> Sync Assessment </span>
          </li>
          <li
            @click="$emit('handleOpenExportData')"
            class="sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100"
          >
            <i class="fas fa-file-download text-base w-4"></i>
            <span class="ml-4">Export Data</span>
          </li>
          <li
            @click="$emit('showDuplicateModal')"
            class="sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100"
          >
            <i class="fa fa-clone text-base w-4"></i>
            <span class="ml-4"> Duplicate RoundTable </span>
          </li>
          <li
            @click="$emit('showEditLrtModal')"
            class="sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100"
          >
            <i class="fa fa-edit text-base w-4"></i>
            <span class="ml-4"> Edit Prompt </span>
          </li>
          <li
            v-if="hasTeacherPermissionsInCourse && getCurrentDiscussion.sequence_id !== null"
            class="sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100 text-gray-700"
            @click="$emit('handleRemoveFromSequence')"
          >
            <i class="fa-solid fa-link-slash text-base"></i>
            <span class="ml-4">Remove from Sequence</span>
          </li>
          <li
            @click="$emit('handleDeleteRoundTable')"
            class="sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100 text-red-500"
          >
            <i class="fa fa-trash text-base w-4"></i>
            <span class="ml-4"> Delete RoundTable </span>
          </li>
        </ul>
      </template>
    </v-dropdown>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import LiveDiscussionService from 'services/liveDiscussion';
  import authenticationService from 'features/authentication/authentication.services';
  import URLconfigs from 'services/apiConfigs';

  export default Vue.extend({
    computed: {
      ...mapGetters(['hasTeacherPermissionsInCourse', 'getCurrentDiscussion'])
    },
    directives: {
      clickOutside: {
        bind(el, binding, vnode) {
          el.clickOutsideEvent = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
              vnode.context[binding.expression](event);
            }
          };
          document.body.addEventListener('click', el.clickOutsideEvent);
        },
        unbind(el) {
          document.body.removeEventListener('click', el.clickOutsideEvent);
        }
      }
    },
    data() {
      return {
        submenuOpen: false,
      };
    },
    methods: {
      toggleSubmenu() {
        this.submenuOpen = !this.submenuOpen;
      },
      closeSubmenu() {
        this.submenuOpen = false;
      },
      handleStartFollowUp: function(type) {
        this.$emit('showFollowUp', type);
      },
      handleAddToUniverse: async function() {
        const toast = { message: "Something happened adding this roundtable to Parlay Universe", time: 5000, type: "Error" };
        try {
          const res = await LiveDiscussionService.addLiveDiscussionToUniverse(this.getCurrentDiscussion.id);
          const payload = {
            id: this.getCurrentDiscussion.id,
            meta: { premade_id: res.data },
            created_universe_premade: true,
          };
          this.$store.dispatch('saveLiveDiscussionSettings', payload);
          const live_discussion_url = `${URLconfigs.universeURL}/live_discussions/${res.data}`;
          authenticationService.navigateToExternalWithAuth(live_discussion_url);
        } catch (error) {
          console.log(error);
          EventBus.$emit('createToast', toast);
        }
      }, 
    },
  });
</script>



// WEBPACK FOOTER //
// liveDiscussionMenu.vue?dec97b5c